import * as React from 'react';
import type { SVGProps } from 'react';
const SvgETransportSend = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={30} height={30} fill="none" {...props}>
    <path fill="#B2B2B2" d="M3.75 1.875h5.625L30 13.125v3.75L9.375 28.125H3.75l1.875-11.25H15v-3.75H5.625z" />
  </svg>
);
export default SvgETransportSend;
